import { Header, Row } from '@/components/SettingsLayout';
import styles from './styles.module.css';
import { useState } from 'react';
import { Input } from '@/ui';
import { useTranslation } from 'react-i18next';
import { CompaniesCount } from '@/store/slices/organizationsSlice';
import { CustomSelect } from '@/components';
import { SelectOption } from '@/types/types';
type Props = {
  debouncedSaveInput: (input: string) => void;
  handleChange: (name: string, value: any) => void;
};
function OrganizationsFilters({ debouncedSaveInput, handleChange }: Props) {
  const [inputValue, setInputValue] = useState('');
  const { t } = useTranslation();

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
    debouncedSaveInput(event.target.value);
    handleChange('search', event.target.value);
  };

  return (
    <Header>
      <Row>
        <div className={styles.sortDiv}>
          <CustomSelect
            menuPosition='fixed'
            onChange={(value: SelectOption) => handleChange('companiesCount', value.value)}
            options={[
              {
                label: t('Accounts.all_companies'),
                value: CompaniesCount.ALL,
              },
              {
                label: t(`Accounts.${CompaniesCount.TEN}`),
                value: CompaniesCount.TEN,
              },
              {
                label: t(`Accounts.${CompaniesCount.FIFTY}`),
                value: CompaniesCount.FIFTY,
              },
              {
                label: t(`Accounts.${CompaniesCount.HUNDRED}`),
                value: CompaniesCount.HUNDRED,
              },
              {
                label: t(`Accounts.${CompaniesCount.HUNDRED_PLUS}`),
                value: CompaniesCount.HUNDRED_PLUS,
              },
            ]}
            defValue={{
              label: t('Accounts.all_companies'),
              value: CompaniesCount.ALL,
            }}
          />
        </div>
      </Row>
      <div className={styles.searchInput}>
        <Input
          size='small'
          variant={'search'}
          value={inputValue}
          placeholder={t('Accounts.search_text')}
          onChange={handleSearch}
        />
      </div>
    </Header>
  );
}

export default OrganizationsFilters;
